import { render, staticRenderFns } from "./DeletePopup.vue?vue&type=template&id=73261191"
import script from "./DeletePopup.vue?vue&type=script&lang=js"
export * from "./DeletePopup.vue?vue&type=script&lang=js"
import style0 from "./DeletePopup.vue?vue&type=style&index=0&id=73261191&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports